<div class="form-field" *ngIf="!(removeCtrl$ | async)" [hidden]="isHidden$ | async" class="form-group row" [formGroup]="form">
	<label class="col-md-3 form-control-label" [attr.for]="field.label"> {{ field?.label }} <strong class="text-danger" *ngIf="showRequiredSign">*</strong> </label>
	<div class="col-md-9" [ngSwitch]="field.type">
		<textbox [disabled]="isDisabled$ | async" *ngSwitchCase="'text'" [field]="field" [form]="form"></textbox>
		<dropdown *ngSwitchCase="'dropdown'" [field]="field" [form]="form"></dropdown> <checkbox *ngSwitchCase="'checkbox'" [field]="field" [form]="form"></checkbox>
		<radio *ngSwitchCase="'radio'" [field]="field" [form]="form"></radio> <file *ngSwitchCase="'file'" [field]="field" [form]="form"></file>
		<div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!isValid && isDirty">
			<div *ngIf="fieldErrors['required']">{{ errorMessages['required'] }}</div>
			<div *ngIf="fieldErrors['minlength']">{{ errorMessages['minLength'] }}</div>
			<div *ngIf="fieldErrors['maxlength']">{{ errorMessages['maxLength'] }}</div>
		</div>
	</div>
</div>
